import OrderPreparationTimeOptions from './OrderPreparationTimeOptions';
import OrderTimeChangeInput from './OrderTimeChangeInput';

export default {
  OrderPreparationTimeOptions,
  OrderTimeChangeInput,
};
